import { QueryClient } from "@tanstack/react-query";

// Single QueryClient shared across the app. Exported so non-React code
// (e.g. the signOut wrapper) can clear the cache without going through a
// hook.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
